import { Seo } from "../components/Seo";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Plane, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
      <Seo title="Reset your password" noindex />
      <div className="w-full max-w-sm">
        <div className="mb-8">
          <img src="/pnr-decode-wordmark.png" alt="PNR Decode" className="h-14 w-auto object-contain" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-slate-900 mb-1">Set new password</h1>
        <p className="text-sm text-slate-500 mb-6">Enter your reset token and a new password.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="token" className="text-slate-700">Reset token</Label>
            <Input data-testid="reset-token" id="token" value={token} onChange={(e) => setToken(e.target.value)} required className="mt-1 font-pnr text-xs" />
          </div>
          <div>
            <Label htmlFor="password" className="text-slate-700">New password</Label>
            <Input data-testid="reset-password" id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" placeholder="At least 6 characters" />
          </div>
          {error && <div data-testid="reset-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>}
          <Button data-testid="reset-submit" type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Reset password"}
          </Button>
        </form>

        <div className="mt-4 text-sm">
          <Link to="/login" className="text-slate-600 hover:underline">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
